import { render } from "./PublicKoTatouCompleted.vue?vue&type=template&id=3d423b02&scoped=true"
import script from "./PublicKoTatouCompleted.vue?vue&type=script&lang=js"
export * from "./PublicKoTatouCompleted.vue?vue&type=script&lang=js"

import "../assets/styles/public-ko-tatou-completed.css?vue&type=style&index=0&id=3d423b02&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d423b02"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn});
